/**
 * The CommunityAnnouncements Root container
 */
import React from "react";
import PropTypes from "prop-types";
import { Route, Switch } from "react-router-dom";
import Loadable from "react-loadable";

/**
 * CommunityAnnouncements Root container, the landing page for logged in users
 */

const CommunityAnnouncementDetail = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "CommunityAnnouncementDetail" */ "./CommunityAnnouncementDetail"
    ),
  loading: () => null,
  modules: ["CommunityAnnouncementDetail"],
});

const CommunityAnnouncements = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "CommunityAnnouncements" */ "./CommunityAnnouncements"
    ),
  loading: () => null,
  modules: ["CommunityAnnouncements"],
});

const CommunityAnnouncementsRoot = () => {
  return (
    <div>
      <Switch>
        <Route
          path={`/:lang/news/:announcementId`}
          component={CommunityAnnouncementDetail}
        />
        <Route path={`/:lang/news`} component={CommunityAnnouncements} />
      </Switch>
    </div>
  );
};

/**  define proptype for the 'translation' function  */
CommunityAnnouncementsRoot.contextTypes = {
  t: PropTypes.func,
};

/** export the component as redux connected component */
export default CommunityAnnouncementsRoot;
